import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-carestaff',
    templateUrl: './carestaff.component.svg',
    styleUrls: ['./carestaff.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarestaffComponent {}
